import React, { useState, useContext } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS, VALIDATION } from "consts";
import SmtpSettings from "./smtpSettings";
import OperationStatus from "./operationStatus";
import { forbidExtraProps } from "utils";
import { SPopupContext } from "App/common/hoc/SlidingPopup";

import {
  toggleNotificationEnable,
  changeNotificationCurrentEmail,
  addNotificationEmail,
  addMultipleNotificationEmail,
  removeNotificationEmail,
  changeNotificationSMTPSetting,
  toggleNotificationOperationStatus
} from "store/actions";
import { CONTENT } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";

function EmailNotification(props) {
  const [invalidEmail, setInvalidEmail] = useState({ show: false, msg: "" });
  const { sPopupState } = useContext(SPopupContext);
  let ref = React.useRef(false);
  let invalidEmailFromPOP = false;
  if (
    sPopupState.validation.params &&
    sPopupState.validation.params.email &&
    sPopupState.validation.params.email.msg
  ) {
    invalidEmailFromPOP = true;
  }

  function validateEmail(e) {
    sPopupState.validation = {
      status: true,
      msg: "",
      params: {}
    };
    e.preventDefault();
    let newEmail = props.emailNotification.emails.current;
    if (
      props.emailNotification.emails.list.filter(
        email =>
          email.toLowerCase() ===
          props.emailNotification.emails.current.toLowerCase()
      ).length > 0
    ) {
      setInvalidEmail({
        show: true,
        msg: VALIDATION.backupSettings.email.duplicate
      });
    } else {
      if (newEmail.split(",").length > 1) {
        let emailsList = newEmail.split(",");
        let correctEmails = [];
        let wrongEmails = [];
        let toolongEmails = [];
        let duplicateEmails = [];
        for (let i = 0; i < emailsList.length; i++) {
          if (emailsList[i].length > 50)
            toolongEmails.push(emailsList[i].replace(" ", ""));
          else if (
            /^([!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64}(\.[!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64})*|"([\]!#-[^-~\ \t\@\\\\]|(\\[\t\ -~]))+")@([0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?))+$/i.test(
              emailsList[i].replace(" ", "")
            )
          ) {
            if (
              props.emailNotification.emails.list.filter(
                email =>
                  email.toLowerCase() ===
                  emailsList[i].replace(" ", "").toLowerCase()
              ).length > 0 ||
              correctEmails.filter(
                email =>
                  email.toLowerCase() ===
                  emailsList[i].replace(" ", "").toLowerCase()
              ).length > 0
            ) {
              duplicateEmails.push(emailsList[i].replace(" ", ""));
            } else correctEmails.push(emailsList[i].replace(" ", ""));
          } else wrongEmails.push(emailsList[i].replace(" ", ""));
        }
        if (wrongEmails.length > 0) {
          setInvalidEmail({
            show: true,
            msg: VALIDATION.backupSettings.email.valid
          });
        } else if (duplicateEmails.length > 0) {
          setInvalidEmail({
            show: true,
            msg: VALIDATION.backupSettings.email.duplicate
          });
        } else if (toolongEmails.length > 0) {
          setInvalidEmail({
            show: true,
            msg: VALIDATION.backupSettings.email.long
          });
        } else setInvalidEmail({ show: false, msg: "" });
        wrongEmails.push.apply(wrongEmails, duplicateEmails);
        wrongEmails.push.apply(wrongEmails, toolongEmails);
        props.addMultipleNotificationEmail(
          correctEmails,
          wrongEmails.join(", ")
        );
      } else {
        if (newEmail.length > 50) {
          setInvalidEmail({
            show: true,
            msg:
              newEmail === ""
                ? VALIDATION.backupSettings.email.default
                : VALIDATION.backupSettings.email.long
          });
        } else if (
          /^([!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64}(\.[!#-\'*+\/-9=?A-Z^-~\\\\-]{1,64})*|"([\]!#-[^-~\ \t\@\\\\]|(\\[\t\ -~]))+")@([0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Z]([0-9A-Z-]{0,61}[0-9A-Za-z])?))+$/i.test(
            newEmail
          )
        ) {
          setInvalidEmail({ show: false, msg: "" });
          props.addNotificationEmail();
        } else {
          setInvalidEmail({
            show: true,
            msg:
              newEmail === ""
                ? VALIDATION.backupSettings.email.default
                : VALIDATION.backupSettings.email.valid
          });
        }
      }
    }
    if (prevState => prevState) {
      ref.current = true;
    }
  }

  const onchangeHandler = val => {
    delete sPopupState.validation.params.email;
    props.changeNotificationCurrentEmail(val);
    if (invalidEmail.show) {
      ref.current = false;
    } else {
      ref.current = true;
    }
  };

  return (
    <React.Fragment>
      <div className="send_email">
        <p>
          {CONTENT.backupSettings.eNotification.send}{" "}
          <Tooltip {...TOOLTIPS.backupSettings.email.notification}>
            <span className="icon">
              <InformationIcon />
            </span>
          </Tooltip>
        </p>
        <form
          className="send_email_int_btn just_flex"
          onSubmit={e => validateEmail(e)}
        >
          <div className="err_msg_wrap">
            <input
              type="text"
              className="input_text"
              onChange={e => onchangeHandler(e.target.value)}
              value={props.emailNotification.emails.current}
              autoFocus={true}
              tabIndex={0}
            />
            <div>
              {ref.current && invalidEmail.show && !invalidEmailFromPOP && (
                <span className={"error-msg active"}>
                  {invalidEmail && invalidEmail.msg !== ""
                    ? invalidEmail.msg
                    : VALIDATION.backupSettings.email.error}
                </span>
              )}
              {invalidEmailFromPOP && (
                <span className="error-msg active">
                  {sPopupState.validation.params &&
                  sPopupState.validation.params.email &&
                  sPopupState.validation.params.email.msg !== ""
                    ? sPopupState.validation.params.email.msg
                    : VALIDATION.backupSettings.email.error}
                </span>
              )}
            </div>
          </div>
          <Tooltip {...TOOLTIPS.backupSettings.email.addemail}>
            <button
              className="slider_btn btn_primary email_add"
              onSubmit={validateEmail}
              tabIndex={0}
            >
              Add
            </button>
          </Tooltip>
        </form>
        {props.emailNotification.emails.list.length > 0 ? (
          <div className="int_email_chips active">
            {props.emailNotification.emails.list.map((email, i) => (
              <div className="chip" key={i}>
                <p>{email}</p>
                <span
                  className="chip_close"
                  onClick={() => props.removeNotificationEmail(i)}
                />
              </div>
            ))}
          </div>
        ) : (
          ""
        )}
      </div>

      <SmtpSettings
        smtpSettings={props.emailNotification.smtpSettings}
        changeNotificationSMTPSetting={props.changeNotificationSMTPSetting}
        emailsList={props.emailNotification.emails.list}
      />
      <OperationStatus
        operationStatus={props.emailNotification.operationStatus}
        toggleNotificationOperationStatus={
          props.toggleNotificationOperationStatus
        }
      />
    </React.Fragment>
  );
}

EmailNotification.propTypes = forbidExtraProps(
  {
    emailNotification: PropTypes.shape({
      emails: PropTypes.shape({
        list: PropTypes.arrayOf(PropTypes.string).isRequired
      }),
      operationStatus: PropTypes.object.isRequired,
      enabled: PropTypes.bool.isRequired,
      smtpSettings: PropTypes.shape({
        password: PropTypes.string.isRequired,
        port: PropTypes.number.isRequired,
        serverName: PropTypes.string.isRequired,
        userName: PropTypes.string.isRequired
      }).isRequired,
      reportFrequency: PropTypes.number.isRequired,
      reportStatus: PropTypes.number.isRequired
    }).isRequired
  },
  [
    "toggleNotificationEnable",
    "changeNotificationCurrentEmail",
    "addNotificationEmail",
    "addMultipleNotificationEmail",
    "removeNotificationEmail",
    "changeNotificationSMTPSetting",
    "toggleNotificationOperationStatus"
  ]
);

function mapStateToProps(state) {
  return {
    emailNotification: state.backupSettings.emailNotification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleNotificationEnable,
      changeNotificationCurrentEmail,
      addNotificationEmail,
      addMultipleNotificationEmail,
      removeNotificationEmail,
      changeNotificationSMTPSetting,
      toggleNotificationOperationStatus
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailNotification);
